import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import RequireDoctor from './components/RequireDoctor';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const CredentialingEntry = lazy(() => import('./pages/CredentialingEntry'));
const OnboardingStep = lazy(() => import('./pages/OnboardingStep'));
const OnboardingStatus = lazy(() => import('./pages/OnboardingStatus'));
const DoctorHome = lazy(() => import('./pages/Home'));
const DoctorProfilePage = lazy(() => import('./pages/Profile'));
const DoctorRolesPage = lazy(() => import('./pages/Roles'));
const DoctorAgendaPage = lazy(() => import('./pages/Agenda'));

/**
 * Rotas do ambiente do médico (A3): credenciamento (T-27..T-32), início (T-33), perfil (T-38), papéis (T-39), agenda (T-37).
 * Telas de plantão/sala (/medico/plantao, /medico/atendimentos, /medico/atendimento/:id) são do A1 e entram no bloco abaixo.
 */
const routes: RouteObject[] = [
  // credenciamento — entrada pública; os passos exigem perfil DOCTOR + 2FA
  { path: '/medico/credenciamento', element: <CredentialingEntry /> },
  { path: '/medico/credenciamento/passo/:n', element: <RequireDoctor><OnboardingStep /></RequireDoctor> },
  { path: '/medico/credenciamento/status', element: <RequireDoctor><OnboardingStatus /></RequireDoctor> },

  // ambiente do médico credenciado
  { path: '/medico', element: <RequireDoctor released><DoctorHome /></RequireDoctor> },
  { path: '/medico/perfil', element: <RequireDoctor released><DoctorProfilePage /></RequireDoctor> },
  { path: '/medico/papeis', element: <RequireDoctor released><DoctorRolesPage /></RequireDoctor> },
  { path: '/medico/agenda', element: <RequireDoctor released><DoctorAgendaPage /></RequireDoctor> },

  // --- A1 (plantão/sala): adicionar rotas aqui ---
];
export default routes;
